import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { businessInfo } from '../data/mock';

export const Footer = ({ onContactClick }) => {
  const navigate = useNavigate();

  const scrollToSection = (id) => {
    // Navigate to home first if not already there
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <footer className="bg-emerald-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold text-amber-500 mb-4">
              Claim A Trademark
            </h3>
            <p className="text-emerald-100">
              Professional trademark registration services to protect your brand and secure your business identity nationwide.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-500">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-emerald-100 hover:text-amber-500 transition-colors">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-emerald-100 hover:text-amber-500 transition-colors">
                  Our Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('pricing')} className="text-emerald-100 hover:text-amber-500 transition-colors">
                  Pricing Plans
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('process')} className="text-emerald-100 hover:text-amber-500 transition-colors">
                  Registration Process
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('faq')} className="text-emerald-100 hover:text-amber-500 transition-colors">
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-500">Our Services</h4>
            <ul className="space-y-2 text-emerald-100">
              <li>Trademark Search & Analysis</li>
              <li>Federal Trademark Filing</li>
              <li>Office Action Response</li>
              <li>Trademark Monitoring</li>
              <li>Cease & Desist Letters</li>
              <li>Trademark Renewal</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-500">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin className="h-5 w-5 mr-2 mt-1 flex-shrink-0 text-amber-500" />
                <span className="text-emerald-100">{businessInfo.address}</span>
              </li>
              <li className="flex items-center">
                <Phone className="h-5 w-5 mr-2 flex-shrink-0 text-amber-500" />
                <a href={`tel:${businessInfo.phone}`} className="text-emerald-100 hover:text-amber-500 transition-colors">
                  {businessInfo.phone}
                </a>
              </li>
              <li className="flex items-center">
                <Mail className="h-5 w-5 mr-2 flex-shrink-0 text-amber-500" />
                <a href={`mailto:${businessInfo.email}`} className="text-emerald-100 hover:text-amber-500 transition-colors">
                  {businessInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-emerald-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-emerald-200 text-sm text-center md:text-left">
              © {new Date().getFullYear()} Claim A Trademark. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <Link to="/privacy-policy" className="text-emerald-200 hover:text-amber-500 transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms-conditions" className="text-emerald-200 hover:text-amber-500 transition-colors">
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
